import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Footer from "./Footer";
import Sidebar from "./Sidebar";
import HeaderAlt from "../HeaderAlt";
import TailwindHeader from "../TailwindHeader";
import { Container } from "react-bootstrap";

const Layout = ({ children, sidebar }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  return (
    <div className="relative">
      {/* <HeaderAlt siteTitle={data.site.siteMetadata.title} /> */}
      <TailwindHeader />
      <div className="px-3 mb-8 min-h-screen pt-16">
        <Container>
          <div
            className={`block grid-cols-3 gap-6${sidebar ? " lg:grid" : ""}`}
          >
            <main className="col-span-2 lg:mb-0 mb-6">{children}</main>
            {sidebar && (
              <aside className="col-span-1">
                <Sidebar sections={sidebar} />
              </aside>
            )}
          </div>
        </Container>
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
